export default {
  name: 'index',
  components: {},
  data: function data() {
    return {};
  },
  methods: {},
  mounted: function mounted() {
    if (location.href.indexOf("#reloaded") == -1) {
      location.href = location.href + "#reloaded";
      location.reload();
    }
  }
};